import React from "react";
import { Link } from "react-router-dom";
import LanguageConst from "../language-const";


const LanguageTitleLinkField = ({ language }) => (
    <Link
        className="table-link-underline"
        to={ `${ LanguageConst.basePath }/${ language.id }` }
    >
        <strong>{ language.label || language.slug }</strong>
    </Link>
);

export default LanguageTitleLinkField;
